module.exports = __webpack_public_path__ + "img/22.ff6b0e26.jpg";